export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0487_FC1_0785.8f3f4d2f.jpg";